<div *ngIf="!component" class="tooltip" [innerHTML]="content | sanitizeHtml"></div>

<div *ngIf="component" class="tooltip">
  <ng-container [cdkPortalOutlet]="componentPortal" (attached)="onAttached($event)"></ng-container>
</div>
